__turbopack_context__.v({
  "arrow-left": "PlugAds-module-sass-module__vxVO7W__arrow-left",
  "arrow-left-wrapper": "PlugAds-module-sass-module__vxVO7W__arrow-left-wrapper",
  "arrow-right": "PlugAds-module-sass-module__vxVO7W__arrow-right",
  "arrow-right-wrapper": "PlugAds-module-sass-module__vxVO7W__arrow-right-wrapper",
  "arrows": "PlugAds-module-sass-module__vxVO7W__arrows",
  "autoplay-progress": "PlugAds-module-sass-module__vxVO7W__autoplay-progress",
  "circle": "PlugAds-module-sass-module__vxVO7W__circle",
  "slider": "PlugAds-module-sass-module__vxVO7W__slider",
  "title": "PlugAds-module-sass-module__vxVO7W__title",
  "wrapper": "PlugAds-module-sass-module__vxVO7W__wrapper",
});
